<template>
  <el-table
    :data="caches"
    border
    style="width: 100%"
    class="table"
  >
    <el-table-column
      prop="id"
      :label="$t('cacheManage.cacheId')"
      align="center"
    />
    <el-table-column
      prop="cacheCode"
      :label="$t('cacheManage.cacheCode')"
      align="center"
    />
    <el-table-column
      prop="name"
      :label="$t('cacheManage.name')"
      align="center"
    />
    <el-table-column
      :label="$t('cacheManage.operation')"
      align="center"
    >
      <template #default="{row}">
        <el-button
          size="mini"
          @click="$emit('flush-cache', row)"
        >
          {{ $t('cacheManage.flushCache') }}
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'CacheManageTable',
  props: {
    caches: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.table {
  margin-bottom: 20px;
}
</style>